import { Injectable } from '../../../node_modules/@angular/core';

@Injectable()
export class Common {

    public static loader(action: string): void {
        const loader = document.getElementById('spinner');
        if (loader) {
            loader.classList.remove('fadeOut');
            loader.style.visibility = action === 'show' ? 'visible' : 'hidden';
            loader.style.display = action === 'show' ? 'block' : 'none';
        }
    }
}
